
//Introduction to performance optimization and lazy loading
//https://itnext.io/vue-js-app-performance-optimization-part-1-introduction-to-performance-optimization-and-lazy-29e4ff101019

// import() – dynamically importing ES modules: http://2ality.com/2017/01/import-operator.html

const Revenue = () => import('./components/Revenue/revenue.vue');
import revenueStore from './components/Revenue/store/revenue';

const manageApps = () => import('./components/App/ManageApps/ManageApps.vue');
import manageAppsStore from './components/App/ManageApps/store/manageApps';

const campaignBlockSubAccounts = () => import('./components/ReportByApp/ReportByApp.vue');
import campaignBlockSubAccountsStore from'./components/ReportByApp/store/campaignBlockSubAccounts';

const accountSettings = () => import('./components/Account/AccountSettings/AccountSettings.vue');
import accountSettingsStore from'./components/Account/AccountSettings/store/accountSettings';

const register = () => import('./components/Account/Register/Register.vue');
import registerStore from'./components/Account/Register/store/account';

const GDPRTerms = () => import('./components/Account/VerifyGDPRTerms/VerifyGDPRTerms.vue');

const Manage = () => import('./components/Manage/manage.vue');
import manageStore from './components/Manage/store/manage';

const Reports = () => import('./components/Reports/reports.vue');
import reportsStore from './components/Reports/store/reports';

const Campaign = () => import('./components/Campaign/Campaign.vue');
import campaignStore from './components/Campaign/store/Campaign';

const CustomAudienceByEvents = () => import('./components/Campaign/CustomAudience/CustomAudienceByEvents.vue');
import CustomAudienceByEventsStore from './components/Campaign/CustomAudience/store/custom_audience_by_events_store';

const ApproveDashboard = () => import('./components/ApproveDashboard/ApproveDashboard.vue');
import approveDashboardStore from './components/ApproveDashboard/store/approveDashboard';


export const routes =
    [
        {
            path: '/Discovery/Reports.aspx',
            component: campaignBlockSubAccounts,
            stores: [campaignBlockSubAccountsStore]
        },
        {
            path: '/Apps/Manage.aspx',
            component: manageApps,
            stores: [manageAppsStore]
        },
        {
            path: '/Publisher/Settings.aspx',
            component: accountSettings,
            stores: [accountSettingsStore]
        },
        {
            path: '/Account/Register2.aspx',
            component: register,
            stores: [registerStore]
        },
        {
            path: '/Account/GDPRTerms.aspx',
            component: GDPRTerms
        },
        {
            path: '/Revenue/Reports.aspx',
            component: Revenue,
            stores: [revenueStore]
        },
        {
            path: '/ApproveDashboard/ApproveDashboard.aspx',
            beforeEnter: (to, from, next) => {
                console.log('before enter approve dashboard')
                next();
            },
            component: ApproveDashboard,
            stores: [approveDashboardStore]
        },
        {
            path: '/newDiscovery/Manage.aspx',
            component: Manage,
            stores: [manageStore]
        },
        {
            path: '/newDiscovery/Reports.aspx',
            component: Reports,
            stores: [reportsStore]
        },
        {
            path: '/newDiscovery/Campaign.aspx',
            component: Campaign,
            stores: [campaignStore]
        },
        {
            path: '/Discovery/Campaign.aspx',
            component: CustomAudienceByEvents,
            stores: [CustomAudienceByEventsStore]
        }
    ];


// WEBPACK FOOTER //
// ./src/routes.js